import React, { Fragment, useEffect, useState } from "react";
import thankYou from "../../assets/lottie/thankYou.json";
import Lottie from "lottie-react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getPreAdmissionInfo } from "../../../services/workspace/global.service";
import toast from "react-hot-toast";
import Loading from "../../components/skeleton/loading";
import AppStore from "../../assets/images/appstore.png";
import PlayStore from "../../assets/images/playstore.png";

const ThankYouPage = () => {
  const navigate = useNavigate();
  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  return (
    // <div className="flex flex-col gap-8 justify-center items-center md:h-screen h-auto text-center p-6">
    //   {!loading ? (
    //     <Loading />
    //   ) : (
    //     <Fragment>
    //       <h1 className="text-3xl font-bold text-theme ">
    //         Thank You for Your Inquiry!
    //       </h1>
    //       <div className="">
    //         <Lottie
    //           animationData={thankYou}
    //           loop={true}
    //           className="h-[120px] sm:h-[120px] md:h-[150px]"
    //         />
    //         <span className="flex gap-2 md:hidden items-center justify-center">
    //           <p className="text-textLight">Download App:</p>
    //           <Link
    //             to="https://play.google.com/store/apps/details?id=com.bydo&pli=1"
    //             target="_blank"
    //             className="w-10 h-10 bg-light rounded-md flexCenter border"
    //           >
    //             <img src={PlayStore} width={28} />
    //           </Link>
    //           <Link
    //             to="https://apps.apple.com/us/app/bydo-campus/id6741183879?uo=2"
    //             target="_blank"
    //             className="w-10 h-10 bg-light rounded-md flexCenter border"
    //           >
    //             <img src={AppStore} width={28} />
    //           </Link>
    //         </span>
    //         <h2 className="text-xl font-semibold text-theme mt-6 md:mt-0">
    //           What Next ?
    //         </h2>
    //       </div>

    //       <div className="flex flex-col gap-8">
    //         {/* Future Steps Section */}
    //         <div className="text-center grid grid-cols-1 sm:grid-cols-3 gap-6">
    //           {/* Step 1 */}
    //           <div className="flex flex-col items-center bg-light shadow-md p-6 rounded-lg h-full">
    //             <div className="flex items-center justify-center text-textLight rounded-full text-xl font-bold">
    //               01
    //             </div>
    //             <h3 className="text-lg font-semibold text-theme mt-2">
    //               Review Process
    //             </h3>
    //             <p className="text-primary-700 mt-2 text-cs">
    //               Our admissions team will review your inquiry thoroughly and
    //               ensure all details are accounted for before moving forward.
    //             </p>
    //           </div>

    //           {/* Step 2 */}
    //           <div className="flex flex-col items-center bg-light shadow-md p-6 rounded-lg h-full">
    //             <div className="flex items-center justify-center text-textLight rounded-full text-xl font-bold">
    //               02
    //             </div>
    //             <h3 className="text-lg font-semibold text-theme mt-2">
    //               Follow-Up Communication
    //             </h3>
    //             <p className="text-primary-700 mt-2 text-cs">
    //               You can expect a response via email or a call within 2-3
    //               business days with the information and next steps you need.
    //             </p>
    //           </div>

    //           {/* Step 3 */}
    //           <div className="flex flex-col items-center bg-light shadow-md p-6 rounded-lg h-full">
    //             <div className="flex items-center justify-center text-textLight rounded-full text-xl font-bold">
    //               03
    //             </div>
    //             <h3 className="text-lg font-semibold text-theme mt-2">
    //               Campus Visit (Optional)
    //             </h3>
    //             <p className="text-primary-700 mt-2 text-cs">
    //               You’re welcome to schedule a campus tour to explore our
    //               facilities and get a feel for our learning environment.
    //             </p>
    //           </div>
    //         </div>
    //       </div>

    //       {/* Need Immediate Assistance Section */}
    //       <div className="items-center justify-center">
    //         <h2 className="text-xl font-semibold text-theme mt-4">
    //           Need Immediate Assistance?
    //         </h2>
    //         <p className="mt-2 text-primary-700 text-cs">
    //           If you have any urgent questions, feel free to:
    //         </p>

    //         <span className="flex md:flex-row flex-col gap-0 md:gap-4 text-primary-700 text-cs items-center justify-center">
    //         <p className="flex flex-row gap-4 items-center justify-center ">
    //           Call us at :{" "}
    //           <a
    //             href={`tel:${data?.phone}`}
    //             className="text-theme underline"
    //           >
    //             {data?.phone || "N/A"}
    //           </a>
    //         </p>
    //         <p className="hidden md:flex">|</p>
    //         <p>
    //           Email us at :{" "}
    //           <a
    //             href={`mailto:${data?.email}`}
    //             className="text-theme underline"
    //           >
    //             {data?.email || "N/A"}
    //           </a>
    //         </p>
    //         </span>
    //         <div className="text-sm flex flex-col gap-4 items-center justify-center md:items-center mt-4 text-center ">
    //           <span className="flex gap-2">
    //             <Link
    //               to="https://play.google.com/store/apps/details?id=com.bydo&pli=1"
    //               target="_blank"
    //               className="w-10 h-10 bg-light rounded-md flexCenter border"
    //             >
    //               <img src={PlayStore} width={28} />
    //             </Link>
    //             <Link
    //               to="https://apps.apple.com/us/app/bydo-campus/id6741183879?uo=2"
    //               target="_blank"
    //               className="w-10 h-10 bg-light rounded-md flexCenter border"
    //             >
    //               <img src={AppStore} width={28} />
    //             </Link>
    //           </span>
    //           {(data?.phone || data?.email) && (
    //             <span className="text-white flex flex-row gap-2">
    //               {data?.phone && (
    //                 <a
    //                   href={`tel:${data.phone}`}
    //                   className="text-blue-500 hover:underline"
    //                 >
    //                   {data.phone}
    //                 </a>
    //               )}
    //               {data?.phone && data?.email && " | "}
    //               {data?.email && (
    //                 <a
    //                   href={`mailto:${data.email}`}
    //                   className="text-blue-500 hover:underline"
    //                 >
    //                   {data.email}
    //                 </a>
    //               )}
    //             </span>
    //           )}
    //           <span className="">
    //             <p>© 2025 bydo.io, Inc. All rights reserved.</p>
    //             <p>
    //               <a
    //                 href="https://bydo.io/campus/privacy"
    //                 target="_blank"
    //                 rel="noopener noreferrer"
    //                 className="text-blue-500 hover:underline"
    //               >
    //                 Privacy Policy
    //               </a>
    //               &nbsp;|&nbsp;
    //               <a
    //                 href="https://bydo.io/campus/term"
    //                 target="_blank"
    //                 rel="noopener noreferrer"
    //                 className="text-blue-500 hover:underline"
    //               >
    //                 Terms of Condition
    //               </a>
    //             </p>
    //           </span>
    //         </div>
    //       </div>
    //     </Fragment>
    //   )}
    // </div>
    <div className="flex flex-col gap-8 justify-center items-center md:h-screen h-auto text-center p-6">
      {!loading ? (
        <Loading />
      ) : (
        <Fragment>
          <h1 className="text-3xl font-bold text-theme ">
            Thank You for Applying!
          </h1>

          <div className="">
            <Lottie
              animationData={thankYou}
              loop={true}
              className="h-[120px] sm:h-[120px] md:h-[150px]"
            />

            <h2 className="text-xl font-semibold text-theme mt-6 md:mt-0">
              What Happens Next?
            </h2>
          </div>

          <div className="flex flex-col gap-8">
            {/* Steps after job application */}
            <div className="text-center grid grid-cols-1 sm:grid-cols-3 gap-6">
              {/* Step 1 */}
              <div className="flex flex-col items-center bg-light shadow-md p-6 rounded-lg h-full">
                <div className="flex items-center justify-center text-textLight rounded-full text-xl font-bold">
                  01
                </div>
                <h3 className="text-lg font-semibold text-theme mt-2">
                  Application Review
                </h3>
                <p className="text-primary-700 mt-2 text-cs">
                  Our recruitment team will carefully review your resume and
                  application details to match you with the job requirements.
                </p>
              </div>

              {/* Step 2 */}
              <div className="flex flex-col items-center bg-light shadow-md p-6 rounded-lg h-full">
                <div className="flex items-center justify-center text-textLight rounded-full text-xl font-bold">
                  02
                </div>
                <h3 className="text-lg font-semibold text-theme mt-2">
                  Shortlisting & Contact
                </h3>
                <p className="text-primary-700 mt-2 text-cs">
                  If your profile fits the role, you will be contacted by our HR
                  team within the next few working days for further steps.
                </p>
              </div>

              {/* Step 3 */}
              <div className="flex flex-col items-center bg-light shadow-md p-6 rounded-lg h-full">
                <div className="flex items-center justify-center text-textLight rounded-full text-xl font-bold">
                  03
                </div>
                <h3 className="text-lg font-semibold text-theme mt-2">
                  Interview Process
                </h3>
                <p className="text-primary-700 mt-2 text-cs">
                  Shortlisted candidates will be scheduled for interviews based
                  on their experience and skillset.
                </p>
              </div>
            </div>
          </div>

          {/* Need Immediate Assistance Section */}
          <div className="items-center justify-center">
            <h2 className="text-xl font-semibold text-theme mt-4">
              Need Immediate Assistance?
            </h2>
            <p className="mt-2 text-primary-700 text-cs">
              If you have any urgent queries regarding your job application,
              contact us:
            </p>

            <span className="flex md:flex-row flex-col gap-0 md:gap-4 text-primary-700 text-cs items-center justify-center">
              <p className="flex flex-row gap-2 items-center justify-center">
                Call us at :
                <a href={`tel:${data?.phone}`} className="text-theme underline">
                  {data?.phone || "N/A"}
                </a>
              </p>

              <p className="hidden md:flex">|</p>

              <p>
                Email us at :
                <a
                  href={`mailto:${data?.email}`}
                  className="text-theme underline"
                >
                  {data?.email || "N/A"}
                </a>
              </p>
            </span>

            <div className="text-sm flex flex-col gap-4 items-center justify-center mt-4 text-center">
              <span className="">
                <p>
                  © 2025{" "}
                  <a
                    href="https://bydo.io"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:underline"
                  >
                    bydo.io
                  </a>{" "}
                  All rights reserved.
                </p>
                <p>
                  <a
                    href="https://bydo.io/hr/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:underline"
                  >
                    Privacy Policy
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://bydo.io/term"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:underline"
                  >
                    Terms & Conditions
                  </a>
                </p>
              </span>
            </div>
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default ThankYouPage;
